import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { colors } from 'styles/theme'
import PublisherDropdown from './PublisherDropdown'

const TopBar = () => {
  return (
    <>
      <Container sx={{ px: 3 }}>
        <ContentWrapper>
          <Typography fontWeight="600">
            Offer Wall Publisher Dashboard
          </Typography>
        </ContentWrapper>
        <ContentWrapper>
          <PublisherDropdown />
        </ContentWrapper>
      </Container>
    </>
  )
}

export default TopBar

const Container = styled('div')`
  width: 100%;
  height: 60px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ContentWrapper = styled('div')`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: normal;
  color: ${colors.gray[900]};
  display: flex;
  justify-content: center;
`
